import { render, staticRenderFns } from "./MetricAdminView.vue?vue&type=template&id=2838a7ea&scoped=true&"
import script from "./MetricAdminView.vue?vue&type=script&lang=js&"
export * from "./MetricAdminView.vue?vue&type=script&lang=js&"
import style0 from "./MetricAdminView.vue?vue&type=style&index=0&id=2838a7ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2838a7ea",
  null
  
)

export default component.exports